import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=190257ff&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/figma.css?vue&type=style&index=0&id=190257ff&scoped=true&lang=css&"
import style1 from "./Add.vue?vue&type=style&index=1&id=190257ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190257ff",
  null
  
)

export default component.exports